var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg005Gps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "33px",
    viewBox: "0 0 41 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0551233152 40.8649078 0.0551233152 40.8649078 23.050682 0 23.050682"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tom",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 9.203272)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0728175115,18.2639885 L8.21802488,0.767380184 C8.35897419,0.464320276 8.67847189,0.285582949 9.01043963,0.324126728 L16.0805779,1.14337097 C16.1474627,1.15111751 16.2151032,1.15017281 16.2816101,1.14053687 L23.6789926,0.0632004608 C23.7572138,0.0518640553 23.8365687,0.0524308756 23.9146009,0.0650898618 L31.8028498,1.3391129 C32.0630203,1.38124654 32.2838912,1.55242627 32.3896977,1.79370276 L40.7982876,20.9905829 C41.0544903,21.5757304 40.5332046,22.2026336 39.9112138,22.0573387 L26.6627346,18.9626889 C26.5268866,18.930947 26.3849926,18.9366152 26.2519788,18.9787488 L13.5187392,23.0145092 C13.3715548,23.0611774 13.2136009,23.0626889 13.0652829,23.0190438 L0.556882028,19.3354677 C0.101914286,19.2015092 -0.127458986,18.6940161 0.0728175115,18.2639885",
    id: "Fill-1",
    fill: "#F6F7F8",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#64BDDC",
    points: "37.4241954 28.2889608 26.3600525 25.7042604 25.2668452 19.7481129 25.0728037 18.6755 23.7753521 11.6008272 30.5996793 12.7040484 34.4308175 21.4593433 34.4359189 21.4593433 34.9723198 22.690477"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#E35646",
    points: "23.7776005 11.599788 16.2171627 12.7062212 13.2668631 29.8551797 26.3590889 25.7062442"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#64BDDC",
    points: "16.2152733 12.7040673 14.519347 22.5729751 14.3304069 23.6659935 13.2678078 29.8571825 2.93920876 26.8127908 5.75384931 20.7646295 6.18803364 19.8350442 9.85573871 11.9685235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9043502,5.66820277e-05 C10.8362811,5.66820277e-05 7.5383318,3.29800599 7.5383318,7.36607512 C7.5383318,10.9810659 13.3550415,19.0346373 14.6506037,20.7836558 C14.7781382,20.9559691 15.0305622,20.9559691 15.1580968,20.7836558 C16.453659,19.0346373 22.2703687,10.9810659 22.2703687,7.36607512 C22.2703687,3.29800599 18.9724194,5.66820277e-05 14.9043502,5.66820277e-05",
    id: "Fill-10",
    fill: "#314D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9043502,3.07583134 C12.5350415,3.07583134 10.6142765,4.99659631 10.6142765,7.36590507 C10.6142765,9.73540276 12.5350415,11.6561677 14.9043502,11.6561677 C17.273659,11.6561677 19.194424,9.73540276 19.194424,7.36590507 C19.194424,4.99659631 17.273659,3.07583134 14.9043502,3.07583134",
    id: "Fill-12",
    fill: "#F6F7F8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#F2F2F2",
    points: "34.972282 22.690477 25.2668074 19.7481129 25.1800839 19.722606 14.4275032 23.6967719 14.330388 23.6661636 5.75383041 20.7647995 6.18801475 19.8350253 14.4120101 22.6137673 14.5193281 22.5729562 25.0727659 18.6755 25.1492866 18.6448917 34.4307797 21.4593433 34.4358811 21.4593433"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#F2F2F2",
    points: "25.6346171 18.910447 24.6283221 19.0942857 23.2747553 11.6721521 23.7752576 11.6007327 24.3116585 11.6876452"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg005Gps);
export default __webpack_public_path__ + "static/media/005-gps.d64104dff4f5a8fe0c637c4ae8c01bf0.svg";
export { ForwardRef as ReactComponent };